import { register } from '../component.js';
import 'react';

var _socialIcons_developer = register("developer.mozilla", {
  "color": "#236ab4",
  "path": "M0 0v64h64V0zm32 48.35h-3.69v-32.7l-10.15 32.7h-4.15l10.11-32.7H32zm18 0h-3.69v-32.7l-10.12 32.7h-4.15l10.11-32.7H50z"
});

export { _socialIcons_developer as default };